<template>
  <iv-row :gutter="16" class="pages-input">
    <iv-col :sm="16" :xl="18">
      <AdmPanel class="pdf-panel" hideHeader>
        <div class="adm-panel__title" style="background: #fff; padding: 12px;"><h2>报告录入</h2></div>
        <div class="tools">
          报告：
          <iv-select size="small" v-model="sources.reportId" style="width:130px">
            <iv-option v-for="(item,index) in options.reportTypes" :key="item.id" :value="item.id"
              :label="item.title">
              <span>{{ item.title }}</span>
            </iv-option>
          </iv-select>
        </div>
        <div
          class="content"
          @mouseup="onMouseUp">
          <div :class="{ 'content-view__empty': status[PDF_VIEWER].loading }" v-if="status[PDF_VIEWER].loading">
            <h3><iv-icon type="ios-filing-outline"></iv-icon></h3>
            <h3 v-if="!sources.report.id && options.thirdTargets.length>0">没有报告内容</h3>
            <h3 v-else>请在右侧搜索企业社报</h3>
          </div>
          <div v-else>
            <PDFViewer
              height="calc(100vh - 96px - 51px)"
              :url="pdf_url"
              @scroll="scroll" />
            <!-- <HightLight ref="hightlight" @getNote="addValueHandle" /> -->
          </div>
        </div>

        <div class="floatButton" :style="floatButtonStyle" v-show="floatButtonShown">
          <a href="javascript:;" @click="onExtract">
            <iv-icon type="ios-plus-outline" size="14"></iv-icon>
            <span>添加到报告值</span>
          </a>
        </div>
      </AdmPanel>
    </iv-col>
    <iv-col :sm="8" :xl="6">
      <AdmPanel hideHeader>
        <div class="content" :class="{ content__empty: status[ANNUAL].loading }">
          <!-- <CheckedList hiddenTitle :maximun="1" :hasCleanButton="false" :sources="options.industries" :checked="industryIdList" @changed="onIndustryIdChange($event[0])" /> -->
          <FilterBar class="filterbalaaaaar" v-model="conditions" :condition="options.filter_rules">
            <iv-form-item slot="before">
              <iv-select filterable v-model="sources.industryId" clearable placeholder="行业" style="width:130px"
                @on-change="onIndustryIdChange(sources.industryId)">
                <iv-option v-for="(item,index) in options.industries" :key="item.id" :label="item.title"
                  :value="item.id">
                  <span>{{ item.title }}</span>
                </iv-option>
              </iv-select>
            </iv-form-item>
            <iv-form-item slot="before">
              <iv-select filterable v-model="sources.report.stockCode" clearable :disabled="loader[COMPANY]" placeholder="企业名称/股票号" style="width:130px">
                <iv-option v-for="(item,index) in options.companys" :key="item.stockCode+index" :label="item.stockCode + ' ' + item.abbreviation" :value="item.stockCode">
                  <span>{{ item.stockCode + " " + item.abbreviation }}</span>
                </iv-option>
              </iv-select>
            </iv-form-item>
            <div>
              <iv-button type="info" :disabled="loader[COMPANY]" @click="handleSearch">
                <iv-icon type="md-search" size="14" style="vertical-align: text-bottom" />
                搜索
              </iv-button>
            </div>
          </FilterBar>
          <hr />
          <!-- <iv-button-group style="margin:10px 0;">
            <iv-button v-for="item in options.reportTypes" :key="item.id" size="small" :type="item.id == sources.reportDataType ? 'primary' : undefined" @click="sources.reportDataType = item.id">
              {{ item.name }}
            </iv-button>
          </iv-button-group> -->
          <div :class="{ 'content-view__empty': status[ANNUAL].loading }" v-if="status[ANNUAL].loading">
            <h3><iv-icon type="levels"></iv-icon></h3>
            <h3>请搜索企业社报</h3>
          </div>
          <div v-else>
            <template v-if="!!sources.industryId">
              <iv-form :ref="FORM_NAME" :model="sources.reportData" label-position="top" :rules="options.validation.reportData">
                <iv-form-item label="指标" prop="thirdTargetNum">
                  <div slot="label">
                    <span style="margin-right: 3px">指标</span>
                    <a href="javascript:;" @click="showTargetRuleExplainNotice()"><iv-icon size="14" type="md-alert"/></a>
                    <span style="display: inline-block;margin: 3px 12px 0 12px;">
                      <iv-circle
                        :percent="thirdTargetsProgress"
                        :size="12"
                        :stroke-width="16"
                        :trail-width="18"
                        style="vertical-align: bottom" />
                      <span> 已录数据 {{ thirdTargetsProgress }}% </span>
                      <a href="javascript:;" @click="showReportData" style="position:relative;z-index:99">点击查看 </a>
                    </span>
                  </div>

                  <div class="adm-flex-group">
                    <iv-select @on-change="thirdTargetsSelectChangeHandle" v-model="sources.reportData.thirdTargetNum">
                      <iv-option v-for="(item, index) in options.thirdTargets" :key="item.thirdTargetNum" :label="item.thirdTargetName" :value="item.thirdTargetNum">
                        <span>{{ item.thirdTargetName }}</span>
                      </iv-option>
                    </iv-select>
                    <div class="ui-unshrink">
                      <span style="padding: 0 10px">{{sources.reportData.audit}}</span>
                    </div>
                  </div>
                </iv-form-item>

                <iv-form-item>
                  <div slot="label">
                    <span>{{ `搜索 (${finderStatus}) ` }}</span>
                    <a v-rbac-allow.hidden="['carbonReport','edit']" href="javascript:;" @click="handleJumpToInput" style="margin:0 5px">编辑关键词 <iv-icon type="forward" /></a>
                    <!-- <iv-button-group style="margin-left: 10px">
                          <iv-button :type="sources.complexForm==0 ? 'primary' : 'ghost'" size="small" @click="sources.complexForm=0" >简</iv-button>
                          <iv-button :type="sources.complexForm==1 ? 'primary' : 'ghost'" size="small" @click="sources.complexForm=1" >繁</iv-button>
                      </iv-button-group> -->
                  </div>
                  <div class="adm-flex-group">
                    <PDFFindbar
                      ref="pdf_findbar"
                      v-model="sources.keyword.value"
                      hiddenButtons
                      :keywords="options.keywords"
                      @finded="pdfFinderHandle"
                      style="width: 90%; display: inline-block;" />
                    <div class="ui-unshrink">
                      <iv-dropdown  @on-click="typeface">
                          <a href="javascript:void(0)">
                              翻译
                              <iv-icon type="md-arrow-dropdown"></iv-icon>
                          </a>
                          <iv-dropdown-menu slot="list" v-for="item in options.language" :key="item.id">
                              <iv-dropdown-item :name="item.id">{{ item.name }}</iv-dropdown-item>
                          </iv-dropdown-menu>
                      </iv-dropdown>
                    </div>
                  </div>
                  <iv-button-group>
                    <iv-button type="default" title="上一个" size="small" :disabled="sources.keyword.current <= 1" @click="$refs.pdf_findbar.prev()" >
                      <iv-icon type="md-arrow-dropleft"></iv-icon>
                    </iv-button>
                    <iv-button type="default" title="下一个" size="small" :disabled="sources.keyword.current >= sources.keyword.total" @click="$refs.pdf_findbar.next()" >
                      <iv-icon type="md-arrow-dropright"></iv-icon>
                    </iv-button>
                    <iv-button title="定位" type="default" size="small" :disabled="sources.keyword.total <= 0" @click="$refs.pdf_findbar.point()" >
                      <iv-icon type="ios-sunny"></iv-icon>
                    </iv-button>
                    <iv-button title="搜索" type="default" size="small" @click="$refs.pdf_findbar.find()" >
                      <iv-icon type="md-search"></iv-icon>
                    </iv-button>
                  </iv-button-group>
                </iv-form-item>

                <iv-form-item :error="validation.form_item.value.text" prop="value">
                  <div class="adm-flex-group" slot="label">
                    <span class="ui-grow"> {{ `报告值（单位：${repeatDataUnit}）` }}</span>
                    <div class="adm-flex-group">
                      <iv-dropdown
                        v-rbac-allow.hidden="['carbonReport','edit']"
                        @on-click="currencyExchange('元', $event)">
                          <a href="javascript:void(0)">
                              汇率转换
                              <iv-icon type="md-arrow-dropdown"></iv-icon>
                          </a>
                          <iv-dropdownMenu slot="list">
                              <template v-for="item in options.currency">
                                <iv-DropdownItem :name="item.id" :key="item.id">{{ item.name }}</iv-DropdownItem>
                              </template>
                          </iv-dropdownMenu>
                      </iv-dropdown>
                      <iv-dropdown style="margin-left: 15px;"
                      v-rbac-allow.hidden="['carbonReport','edit']"
                        @on-click="currencyExchange($event)">
                          <a href="javascript:void(0)">
                              单位转换
                              <iv-icon type="md-arrow-dropdown"></iv-icon>
                          </a>
                          <iv-dropdownMenu slot="list">
                              <template v-for="item in options.units">
                                <iv-DropdownItem :name="item.id" :key="item.id">{{ item.name }}</iv-DropdownItem>
                              </template>
                          </iv-dropdownMenu>
                      </iv-dropdown>
                    </div>
                  </div>
                  <iv-input
                    :disabled="!$rbac.allow(['carbonReport', 'edit'], 'disable')"
                    v-model="sources.reportData.value"
                    @on-change="
                      () => {
                        validation.form_item.value.text = null;
                      }
                    "
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 8 }"
                    :loading="loader[CURRENCY_EXCHANGE]"
                  ></iv-input>
                  <div class="text-right">
                    <iv-button
                      v-rbac-allow.hidden="['carbonReport','edit']"
                      size="small"
                      type="primary" ghost
                      @click="translate(sources.reportData.value)">->简体
                    </iv-button>
                    <iv-button
                      v-rbac-allow.hidden="['carbonReport','edit']"
                      size="small"
                      type="primary" ghost
                      @click="
                        () => {
                          sources.reportData.value = '无';
                        }">没有报告值
                    </iv-button>
                  </div>
                </iv-form-item>
                <iv-form-item :label="sources.reportData.targetRule == '0' ? '人工打分': '系统打分'" prop="score">
                  <DropdownSlider
                    :disabled="sources.reportData.targetRule != '0'"
                    :value="sources.reportData.score"
                    @change="sources.reportData.score=$event"
                    :step="0.5"
                    :max="7"
                    :min="0"
                    style="width: 100%"
                  />
                  <!-- <iv-input-number
                    :disabled="sources.reportData.targetRule != '0'"
                    :value="typeof sources.reportData.score == 'string'?0:sources.reportData.score"
                    @input="sources.reportData.score=$event"
                    :step="0.5"
                    :max="999"
                    :min="0"
                    style="width: 100%"
                  ></iv-input-number> -->
                </iv-form-item>
                <iv-form-item label="补充说明" prop="moreRemark">
                  <iv-input
                    :disabled="!$rbac.allow(['carbonReport', 'edit'], 'disable')"
                    v-model="sources.reportData.moreRemark"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8 }"
                    :loading="loader[CURRENCY_EXCHANGE]"
                  ></iv-input>
                </iv-form-item>
              </iv-form>
              <div class="adm-flex-group">
                <!-- <div><iv-checkbox v-model="isFromOutSource" :disabled="!$rbac.allow(['carbonReport', 'edit'], 'disable')">源于外部数据</iv-checkbox></div> -->
                <div class="ui-grow">
                  <iv-button  style="float: right" type="primary" :disabled="!$rbac.allow(['carbonReport', 'edit'], 'disable') || loader[REPORT_DATA]" @click="saveDetail(sources.reportData)">
                    <iv-icon size="14" style="vertical-align: text-bottom" />
                    保存，并录入下一指标
                  </iv-button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </AdmPanel>

      <PreYearReportValuesPanel
        :type="sources.reportDataType"
        :stockCode="sources.report ? sources.report.stockCode : sources.reportData.stockCode"
        :firstTargetNum="sources.reportData.firstTargetNum"
        :thirdTargetNum="sources.reportData.thirdTargetNum"
        :industryId="sources.industryId"
        :year="preYearReportYear"
        :searchTrigger="preYearReportSearchTrigger"
        :expand="true"
        />

      <iv-modal v-model="status[REPORT_DATA].shown" :title="status[REPORT_DATA].title" :width="status[REPORT_DATA].width" closable>
        <!-- <iv-table border :columns="reportDataColumns" :data="options.thirdTargets.filter(item => item.value != '')" /> -->
        <iv-table border :columns="reportDataColumns" :data="options.thirdTargets" @on-sort-change="reportDataSort" />
        <div slot="footer"></div>
      </iv-modal>
    </iv-col>
  </iv-row>
</template>

<script>

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import api from "@/utils/api";
import contact from "@/utils/contact";
import { conditioner, carbon_years, BusinessError, RequestError, isNumber } from "@/utils/";
import config from "@/configs/";

import FilterBar from "@/components/FilterBar";
// import PDFViewer from "@/components/PDFViewer";
// import HightLight from "@/components/HightLight";
// import PDFFindbar from "@/components/PDFFindbar";
import CheckedList from "@/components/CheckedList";
import PreYearReportValuesPanel from "./PreYearReportValuesPanel";
import DropdownSlider from "@/components/DropdownSlider";

import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonIndustryModel from '@/models/CarbonIndustryModel'
import CarbonReportModel from "@/models/CarbonReportModel";
import ReportDataModel from "@/models/ReportDataModel";

const COMPANY = CarbonCompanyModel.ModelName;
const ANNUAL = CarbonCompanyModel.ModelName;
const PDF_VIEWER = "pdf_viewer";
const REPORT = CarbonReportModel.ModelName;
const REPORT_DATA = ReportDataModel.ModelName;
const YEAR_REPORT = "year";
const SOCIAL_REPORT = "social";
const TYPEFACE = "typeface";
const CURRENCY_EXCHANGE = "currency_exchange"
const INDUSTRY = CarbonIndustryModel.ModelName

const FORM_NAME = `${REPORT_DATA}Form`;

const ModelName = ANNUAL;

const options = {
  year: [],
  reportTypes: [],
  language: [
    { id:"cht", name:"->繁体中文" },
    { id:"zh", name:"->简体中文" },
    { id:"en", name:"->英文" },
    { id:"jp", name:"->日语" },
  ],
  audit:[
    {id: '0', name: ''},
    {id: '1', name: '待审核'},
    {id: '2', name: '不通过'},
    {id: '3', name: '通过'},
  ]
};
const _years = carbon_years().map(year => ({ ...year, title: year.name }))
const _conditioner = conditioner(
  {
    limit: { type: Number, default: 10 },
    year: { type: Number, default: null },
    industryId: { type: Number, default: null },
    targetSource: { type: String, default: "" },
    stockCode: { type: String, default: "" },
    firstTargetNum: { type: String, default: "" },
    thirdTargetNum: { type: String, default: "" }
  },
  {
    limit: { type: Number, default: 10 },
    // year: { type: Number, default: null },
    year: { type: val => parseInt(val), default: () => _years[0].id },
    industryId: { type: Number, default: null },
    stockCode: { type: String, default: "" },
    targetSource: { type: String, default: "" },
    industries: { type: Array, default: [] },
    firstTargetNum: { type: String, default: "" },
    thirdTargetNum: { type: String, default: "" }
  }
);
const filter_rules = [
  {
    name: "year",
    type: Array,
    options: carbon_years(),
    placeholder: "年份",
    clearable: true,
    style: { width: "70px" }
  }
];

function columns(vm) {
  const allowControl = vm.$rbac.allow(['carbonReport', 'edit'])
  const columns = [
    {
      title: "年份",
      key: "year",
      align: "center",
      width: 70
    },
    {
      title: "企业名称",
      key: "abbreviation",
      align: "center",
      minWidth: 100
    },
    {
      title: "一级指标",
      key: "firstTargetName",
      align: "center",
      minWidth: 80
    },
    {
      title: "二级指标",
      key: "secondTargetName",
      align: "center",
      minWidth: 120
    },
    {
      title: "三级指标",
      key: "thirdTargetName",
      align: "center",
      minWidth: 120
    },
    {
      title: "指标单位",
      key: "targetUnit",
      align: "center",
      width: 70,
      render(h, params) {
        const item = params.row;
        return <span>{!item.targetUnit ? "--" : item.targetUnit}</span>;
      }
    },
    {
      title: "存档数据",
      key: "value",
      align: "center",
      minWidth: 100,
      sortable: 'custom'
    },
    {
      title: "得分",
      key: "score",
      align: "center",
      width: 90,
      sortable: 'custom'
    },
    {
      title: "补充说明",
      key: "moreRemark",
      align: "center",
      width: 90,
    }
  ]
  if(allowControl) columns.push({
      title: "操作",
      align: "center",
      width: 80,
      render(h, params) {
        const item = params.row;
        return (
          <a href="javascript:;" class="" onClick={() => vm.edit(item)}>
            编辑
          </a>
        );
      }
    })
  return columns;
}

export default {
  name: "annual",
  mixins: [
    LoaderMixin(ANNUAL, REPORT_DATA, COMPANY, REPORT, TYPEFACE, CURRENCY_EXCHANGE,INDUSTRY),
    StatusMixin(ANNUAL)([{ name: "loading", default: true }]),
    StatusMixin(PDF_VIEWER)([{ name: "loading", default: true }]),
    StatusMixin(REPORT_DATA)([
      { name: "title", default: "" },
      { name: "shown", default: false },
      { name: "width", default: "900px" },
      { name: "done", default: false }
    ]),
    ModelMixin({
      contact,
      models: [CarbonCompanyModel, CarbonReportModel, ReportDataModel, CarbonIndustryModel]
    })
  ],
  data() {
    return {
      isFromOutSource: false,
      FORM_NAME,
      ModelName,
      ANNUAL,
      COMPANY,
      REPORT,
      REPORT_DATA,
      PDF_VIEWER,
      TYPEFACE,
      CURRENCY_EXCHANGE,
      INDUSTRY,
      conditions: _conditioner.default(),
      preYearReportSearchTrigger: 0,
      reportDataColumns: columns(this),
      emptySecondTargetsIndex: 0,
      thirdTargetsProgress: 0,
      options: {
        filter_rules,
        unit: "",
        companys: [],
        validation: {
          reportData: ReportDataModel.validation()
        },
        thirdTargets: [],
        emptySecondTargets: [],
        keywords: [],
        industries: [],
        currency: [],
        units: [],
        ...options
      },
      validation: {
        form_item: {
          value: {
            show: false,
            text: ""
          }
        }
      },
      sources: {
        keyword: {
          value: ""
        },
        detail: {},
        report: {
          stockCode: ""
        },
        industryId: "",
        reportId: '',
        reportDataType: 'carbon',
        reportData: {
          stockCode: null,
          year: null,
          score: null,
          value: ""
        },
        complexForm: 0
      },
      pdf_url: "东风日产供应商购车指南.pdf",
      note: '',
      toLang:'',
      floatButtonShown: false,
      floatButtonStyle: {
        top: 0,
        left: 0
      },
      finderStatus: "0/0",
    };
  },
  async mounted() {
    const { query, params } = this.$route;
    let conditions = _conditioner.serialize({ ...query, ...params }); //处理成支持UI的格式

    //加载行业
    if (this.options.industries.length == 0) {
      this.options.industries = await this.refreshIndustries(conditions.year);
    }

    if (!conditions.industryId) {
      this.sources.industryId = conditions.industryId = this.options.industries[0].id
    }

    //行业加载公司列表
    if (conditions.industryId) {
      this.options.companys = await this.refreshCompanys("", conditions.industryId);
    }
    this.refreshCurrency()
    this.refreshUnits()

    this.conditions = conditions;

    if (this.sources.report) {
      this.sources.report.stockCode = conditions.stockCode;
    }

    this.sources.industryId = conditions.industryId;
    // if (conditions.targetSource) {
    //   this.sources.reportDataType = this.sources.reportType = [YEAR_REPORT, SOCIAL_REPORT, "", ""][["0", "1", "2", "3"].indexOf(conditions.targetSource)]; //0-年报；1-社报；2-舆情；3-其他
    // }
    if (!this.conditions.stockCode) return;

    //加载公司报告
    var report = await this.refreshReport(query, params);
    if (!report) return;
    this.sources.report = report ? report : this.sources.report;
    this.refreshPDFViewer(report);

    this.$nextTick(() => {
      //加载出PDF后提示
      this.$ivNotice.info({
        title: "操作提示",
        desc: "选中PDF文档预览的位置按空格可以自由拖动。",
        duration: 3
      });

      //this.refreshIndustry(report)
      //加载录入内容
      this.refreshReportData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(async () => {
      const { query, params } = to;
      let conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }) //处理成支持UI的格式
      };

      //加载行业
      if (this.options.industries.length == 0) {
        this.options.industries = await this.refreshIndustries(conditions.year);
      }

      if (!conditions.industryId) {
        this.sources.industryId = conditions.industryId = this.options.industries[0].id
      }

      //行业加载公司列表
      if (conditions.industryId) {
        this.options.companys = await this.refreshCompanys("", conditions.industryId);
        const company = this.options.companys.find(item=>item.stockCode==conditions.stockCode)
        if(company) this.sources.complexForm = [0,0,1][company.companyType]
        this.sources.industryId = conditions.industryId
      }
      if(this.options.currency.length == 0) this.refreshCurrency()
      if(this.options.units.length == 0) this.refreshUnits()

      this.conditions = conditions;
      if (conditions.stockCode) {
        this.sources.report.stockCode = conditions.stockCode;
      }

      // if (conditions.targetSource) {
      //   this.sources.reportDataType = this.sources.reportType = [YEAR_REPORT, SOCIAL_REPORT, "", ""][["0", "1", "2", "3"].indexOf(conditions.targetSource)]; //0-年报；1-社报；2-舆情；3-其他
      // }

      if (!conditions.stockCode) return;

      var report = await this.refreshReport(query, params);
      //show pdf
      if (report){
        this.sources.report = report ? report : this.sources.report;
        this.refreshPDFViewer(report); //未指定行业
      }

      this.$nextTick(() => {
        //加载出PDF后提示
        this.$ivNotice.info({
          title: "操作提示",
          desc: "选中PDF文档预览的位置按空格可以自由拖动。",
          duration: 3
        });

        //this.refreshIndustry(report)
        this.refreshReportData();
      });
    });
    next();
  },
  beforeDestroy() {
    this.hideTargetRuleExplainNotice();
  },
  methods: {
    $$onRestfulError(MODEL_NAME, action, err) {
      if (MODEL_NAME == REPORT_DATA && action == "save" && err.code == 400) {
        this.validation.form_item.value.text = err.message;
      } else {
        this.$$onError(err, { duration: 0 });
      }
    },
    async refreshCurrency(){
      const result = await api.currencyList()
      if(!result && result.status < 300) return []
      this.options.currency = result.data.data.map(i=>({ ...i, id: i.currency, name: i.currencyName })) || []
    },
    async refreshUnits(){
      const result = await api.unitList()
      if(!result && result.status < 300) return []
      this.options.units = result.data.data.map(i=>({ ...i, id: i.unit, name: i.unitName })) || []
    },
    async refreshCompanys(query, industryId) {
      this.$$loading(COMPANY);
      const res = await this.$$fetch(COMPANY, { stockCode: query, industryId: industryId });
      this.$$loaded(COMPANY);
      return res.data;
    },
    async refreshIndustries(year) {
      const industry = await this.$$fetch(INDUSTRY, {year : year});
      if (industry) return industry.data.map(item => ({ ...item, name: item.industry, title: item.industry }));
    },

    refreshPDFViewer({ savePath }) {
      this.pdf_url = config.debug ? savePath.replace(process.env.VUE_APP_PDF_HOST, "") : savePath;
    },

    selectTargetValueAndScore({ thirdTargetNum, score, value, targetRule, targetRuleExplain, audit, moreRemark }) {
      if (!thirdTargetNum) return;
      this.sources.reportData.thirdTargetNum = thirdTargetNum;
      this.sources.reportData.score = score;
      this.sources.reportData.value = value;
      this.sources.reportData.targetRule = targetRule;
      this.sources.reportData.targetRuleExplain = targetRuleExplain;
      this.sources.reportData.audit = audit;
      this.sources.reportData.moreRemark = moreRemark;

      this.options.unit = this.options.thirdTargets.find(i => i.thirdTargetNum === thirdTargetNum).targetUnit;
      this.options.keywords = this.options.thirdTargets.find(i => i.thirdTargetNum === thirdTargetNum).keyword.split("`");
      if (this.options.keywords.length > 0) {
        //选择第一个关键字
        this.sources.keyword.value = this.options.keywords[0];
      }
    },

    // 这种方式可以废弃掉了
    refreshIndustry(report = this.sources.report) {
      //this.sources.industryId = ""
      const company = this.options.companys.find(item => item.stockCode == report.stockCode);
      if (company && company.industryList) {
        this.options.industries = company.industryList.map(({ industryId: id, industry: name }) => ({ id, name }));
      }
    },

    async changeQuery(query = this.conditions, params = this.$route.params) {
      this.$router.replace({
        name: this.$route.name,
        query: { ..._conditioner.parse(query) },
        params: params
      });

      this.$nextTick(() => {
        //加载出PDF后提示
        // this.$ivNotice.info({
        //     title: "操作提示",
        //     desc: "选中PDF文档预览的位置按空格可以自由拖动。",
        //     duration: 3
        // });
        // this.refreshIndustry(report)
        //this.refreshReportData();
        // this.sources.industryId = ""
        // const company = this.options.companys.find(item=>item.stockCode==this.sources.report.stockCode)
        // if(company && company.industryList){
        //   this.options.industries = company.industryList.map(({ industryId:id, industry:name })=>({ id, name }))
        // }
      });
    },
    async refreshReport({ year } = this.conditions, params = this.$route.params) {
      const { stockCode } = this.sources.report;
      if (!year || !stockCode) {
        return this.$$error(new Error("请选择企业名称/股票号和年份"));
      }

      const report_res = await this.$$fetch(REPORT, {
        year,
        stockCode,
        // abbreviation: ""
      });
      let result;
      const { data: [report_res_data = {}] = [] } = report_res;
      const emptyReport = Object.keys(report_res_data).length == 0;
      console.log(report_res_data,'report_res_data',report_res)
      if ([BusinessError, RequestError, Error].indexOf(report_res.constructor) == -1) {
        if (emptyReport) {
          this.status[PDF_VIEWER].loading = true;
          // this.status[ANNUAL].loading = true; //年报社报与年报社报数据逻辑独立，此处不应该影响到报告数据的显示逻辑
          this.sources.report = { stockCode }
          return this.$$error(new Error("没有获取到年报/社报"));
        } else {
          this.status[PDF_VIEWER].loading = false;
          result = report_res_data;
        }
      }
      result.stockCode = stockCode
      this.options.reportTypes = report_res.data
      this.sources.reportId = this.sources.reportId ? this.sources.reportId : report_res_data.id
      return emptyReport ? undefined : result;
    },
    async refreshReportData(options={}) {
      const {
        industryId = this.sources.industryId,
        stockCode = this.sources.report.stockCode,
        type = this.sources.reportDataType,
        complexForm=this.sources.complexForm,
        params = this.conditions,
        ordering
      } = options
      const { year } = params;
      const report_data_res = await this.$$fetch(REPORT_DATA, {
        type,
        year,
        stockCode,
        industryId,
        abbreviation: "",
        complexForm,
        ordering,
        limit:1000
      });
      if ([BusinessError, RequestError, Error].indexOf(report_data_res.constructor) == -1) {
        const { data: report_data_list = [] } = report_data_res;
        if (report_data_list.length == 0) {
          this.status[ANNUAL].loading = true;
          return;
        } else {
          this.status[ANNUAL].loading = false;

          // 检测数据是否存在异常
          const sameKeyError = report_data_list.some(i=>report_data_list.filter(j=>i.thirdTargetNum==j.thirdTargetNum).length>1)
          if(sameKeyError){
            // window.alert("数据存在异常，请联系管理员")
            this.$$warning({
              content: "数据存在异常，指标数据重复，请联系管理员！",
              duration: 5
            })
          }

          this.options.thirdTargets = report_data_list.map(i => {
            i.audit = typeof(i.audit) == 'string' ? i.audit : this.options.audit.find(tag=>tag.id == i.audit).name
            return ReportDataModel.schema.format(i);
          });
        }
      }

      this.$nextTick(() => {
        //保存 reportData 表单基础数据
        this.sources.reportData.stockCode = stockCode;
        this.sources.reportData.year = year;
        this.filterHasValueSecondTargets(this.options.thirdTargets)

        //判断剩余指标录入情况
        this.autoSelectFirstTarget({
          // status: this.filterHasValueSecondTargets(this.options.thirdTargets).length == 0 ? "done" : !!this.conditions.firstTargetNum && !!this.conditions.thirdTargetNum ? "custom" : "undone",
          // status: "next", // "done"模式选中内容的方式是“下一项”；"undone"模式选中内容的方式是“下一个未完成项”；
          status: !!this.conditions.firstTargetNum && !!this.conditions.thirdTargetNum ? "custom" : "done",
          firstTarget: this.conditions.firstTargetNum,
          secondTarget: this.conditions.thirdTargetNum
        });
      });
    },
    // updateSecondTargetsProgress(current, max) {
    //     this.thirdTargetsProgress = Math.floor((current / max) * 100);
    // },
    filterHasValueSecondTargets(list) {
      let current = list.length - list.filter(i => !i.value).length,
        max = list.length;
      this.thirdTargetsProgress = Math.floor((current / max) * 100);
      return list.filter(i => !i.value);
    },
    autoSelectFirstTarget({ status, firstTarget, secondTarget }) {
      if (status === "done") {
        //指标已全部录入
        this.status[REPORT_DATA].done = true;
        const [first] = this.options.thirdTargets;
        this.selectTargetValueAndScore(first);
      } else if (status === "undone") {
        //选中未录入的指标
        const [first] = this.filterHasValueSecondTargets(this.options.thirdTargets);
        this.selectTargetValueAndScore(first);
      } else if (status === "custom") {
        //选中自定义的指标
        this.thirdTargetsSelectChangeHandle(secondTarget);
      } else if( status === 'next' ){
        const nextIndex = 1+this.options.thirdTargets.findIndex(i=>i.thirdTargetNum==this.sources.reportData.thirdTargetNum)
        const first = this.options.thirdTargets[nextIndex]
        if(!first) return this.$$info({ content: "没有更多指标内容了!", duration: 3 })
        this.filterHasValueSecondTargets(this.options.thirdTargets);
        this.selectTargetValueAndScore(first);
        this.showTargetRuleExplainNotice();
      }
    },
    updateSecondTargetsOptions(item) {
      //options.thirdTargets
      this.options.thirdTargets = this.options.thirdTargets.map(i => {
        if(i.thirdTargetNum !== item.thirdTargetNum) return i;
        return {
          ...i,
          ...item
        }
        // const { thirdTargetNum, value, score, ...rest } = i;
        // const right = thirdTargetNum == item.thirdTargetNum;
        // return {
        //   ...rest,
        //   thirdTargetNum,
        //   value: right ? item.value : value,
        //   score: right ? item.score : score,
        //   moreRemark: right ? item.moreRemark : moreRemark,
        // };
      });
      this.$nextTick(() => {
        this.autoSelectFirstTarget({
          // status: this.filterHasValueSecondTargets(this.options.thirdTargets).length == 0 ? "done" : "undone"
          status: "next"
        });
      });
    },
    pdfFinderHandle({ current, total }) {
      console.log("pdfFinderHandle | keyword::%s, current::%s, total::%s",this.keyword, current, total)
      this.sources.keyword = { ...this.sources.keyword, current, total };
      this.finderStatus = current > 0 ? `${current}/${total}` : "0/0";
    },
    //设置图标的位置
    select($event) {
      var txt;
      if (window.getSelection) {
        //chrome,firefox,opera
        txt = window.getSelection().toString();
      } else if (document.getSelection) {
        //其他
        txt = document.getSelection().toString();
      } else if (document.selection) {
        //IE特有的
        txt = document.selection.createRange().text;
      }
      if (txt == "") return;
      console.log("onSelect::%s", txt)
      this.note = txt;
      this.$refs.hightlight.set({
        top: $event.clientY,
        left: $event.clientX,
        visiable: true
      });
    },
    thirdTargetsSelectChangeHandle(val) {
      //like Y_EC_1
      this.$nextTick(() => {
        const reportData = this.options.thirdTargets.find(i => i.thirdTargetNum === val);
        this.selectTargetValueAndScore(reportData);
        this.showTargetRuleExplainNotice(reportData);
      });
    },
    hideTargetRuleExplainNotice() {
      this.$ivNotice.close("targetRuleExplain");
    },
    showTargetRuleExplainNotice(reportData = this.sources.reportData) {
      if (this.$root.targetRuleExplainNoticeInit == 1) {
        this.hideTargetRuleExplainNotice();
      }
      this.$root.targetRuleExplainNoticeInit = 1;
      if(!reportData.targetRuleExplain) return
      this.$ivNotice.info({
        name: "targetRuleExplain",
        title: "评分规则",
        render: () => {
          return <div style="line-height: 1.5" domPropsInnerHTML={String(reportData.targetRuleExplain).replace(/\n/gi, "<br/>")}></div>;
        },
        duration: 0
      });
    },

    //获取pdf滚动事件
    scroll() {
      this.floatButtonShown = false
      // this.$refs.hightlight.AddIcon.visiable = false; //隐藏按钮
    },
    showIcon(val) {
      this.$refs.hightlight.AddIcon.visiable = val;
    },
    //添加到报告值
    addValueHandle() {
      console.log("addClick::%s", this.note)
      this.sources.reportData.value += `${this.note}\n`;
      this.$refs.hightlight.AddIcon.visiable = false;
    },

    async saveDetail(data) {
      // let inputSource = 0; // 年报
      // if (this.isFromOutSource == true) {
      //   inputSource = 3; // 外部来源
      // } 
      // else if (this.sources.reportType == "social") {
      //   inputSource = 1; // 社报
      // }
      const validate = await this.$refs[FORM_NAME].validate();
      if (!validate) {
        this.$$warning("表单验证不通过，请继续填写。");
        return Promise.reject(new Error("表单验证不通过，请继续填写。"));
      }
      this.validation.form_item.value.text = "";
      this.$$loading(REPORT_DATA);
      const result = await this.$$active(REPORT_DATA, "save", {
        industryId: this.sources.industryId,
        type: this.sources.reportDataType,
        ...data
      });

      if ([BusinessError, RequestError, Error].indexOf(result.constructor) == -1) {
        this.$$loaded(REPORT_DATA);
        //保存至本地并切换下一个指标

        this.$$success(
          `${
            this.options.thirdTargets.find(i => {
              return i.thirdTargetNum == data.thirdTargetNum;
            }).thirdTargetName
          }指标保存成功`
        );

        this.updateSecondTargetsOptions(data);
      } else {
        console.error(result);
      }
      this.$$loaded(REPORT_DATA);
    },
    showReportData() {
      const company = this.options.companys.find(item=>item.stockCode==this.sources.report.stockCode)
      // const reportType = this.sources.reportDataType == 'year' ? '年报' : '社报'
      this.status[REPORT_DATA].title = `${company.companyName}全部指标数据`;
      this.status[REPORT_DATA].shown = true;
    },
    edit(item) {
      this.selectTargetValueAndScore(item);
      this.$nextTick(() => {
        this.status[REPORT_DATA].shown = false;
      });
    },
    handleJumpToInput() {
      let routerJump = this.$router.resolve({
        path: "/carbon/target",
        query: {
          industryId: this.sources.industryId,
          year: this.sources.reportData.year,
          stockCode: this.sources.reportData.stockCode,
          thirdTargetNum: this.sources.reportData.thirdTargetNum
        }
      });
      window.open(routerJump.href, "_blank");
    },
    mergeQuery(query) {
      return {
        ...this.conditions,
        ...query,
        t: (function() {
          return new Date().getTime();
        })()
      };
    },
    async onIndustryIdChange(val) {
      this.changeQuery(this.mergeQuery({ ...this.conditions, industryId: val, stockCode:"" }));
      this.status[ANNUAL].loading = true;
    },
    async typeface(name,words = this.sources.keyword.value){
      this.$$loading(TYPEFACE)
      const result = await api.typeface({ words: words, toLang: name})
      if(!result && result.status < 300) return this.$$loaded(TYPEFACE)
      this.sources.keyword.value = result.data.data.words
      this.$$loaded(TYPEFACE)

      this.$nextTick(()=>this.$refs.pdf_findbar.find())
    },
    async translate(words = this.sources.reportData.value){
      this.$$loading(TYPEFACE)
      const result = await api.typeface({ words, typeface : 0 })
      if(!result && result.status < 300) return this.$$loaded(TYPEFACE)
      this.sources.reportData.value = result.data.data.words
      this.$$loaded(TYPEFACE)
    },
    async currencyExchange(unit="元", currency="", year=this.conditions.year,value=this.sources.reportData.value){
      this.$$loading(CURRENCY_EXCHANGE)
      const result = await api.currencyExchange(value, year, unit, currency)
      if(!result && result.status < 300) return this.$$loaded(CURRENCY_EXCHANGE)
      this.sources.reportData.value = `${result.data.data.value}`
      this.$$loaded(CURRENCY_EXCHANGE)
    },

    //排序
    reportDataSort(val){
        console.log(val,"order")
        const ordering = ["",`-${val.key}`,val.key][["normal","asc","desc"].indexOf(val.order)]
        this.refreshReportData({ ordering })
        // this.refreshReportData(this.currentType, { ...this.currentItem, ordering: ordering })
    },

    //设置选取文字按钮
    onMouseUp(e){
      const selection = document.getSelection()
      this.floatButtonShown = !selection.isCollapsed
      if(!this.floatButtonShown) return
      this.floatButtonStyle.top = `${e.clientY - 10}px`
      this.floatButtonStyle.left = `${e.clientX + 20}px`
      this.note = selection.toString()
    },
    onExtract(){
      this.floatButtonShown = false
      if(!this.note) return
      this.sources.reportData.value += `${this.note}\n`;
    },
    handleSearch() {
      const query = this.mergeQuery({
        ...this.conditions,
        industryId: this.sources.industryId,
        stockCode: this.sources.report ? this.sources.report.stockCode : ''
      });
      this.changeQuery(query);
      this.preYearReportSearchTrigger += 1;
    },
  },
  watch: {
    async ["sources.reportId"](val) {
      const report = this.options.reportTypes.find(i=>i.id == val)
      if(!report) return;
      this.sources.report = report ? report : this.sources.report;
      this.refreshPDFViewer(report);
    },
    'conditions.year': {
      async handler (newVal, oldVal) {
        if (oldVal) {
          this.options.industries = await this.refreshIndustries(newVal);
        }
      }
    },
    ["sources.reportDataType"](val) {
      this.refreshReportData();
    },
    async ["sources.complexForm"](val){
      await this.refreshReportData()
      this.thirdTargetsSelectChangeHandle(this.sources.reportData.thirdTargetNum)
    }
    // ["sources.industryId"]: async function(val, oldVal){
    //     debugger
    //     this.sources.report.stockCode = ''
    //     this.options.companys = await this.refreshCompanys(this.conditions.stockCode ? this.conditions.stockCode : '', val)
    //     // 只是更新下公司列表
    //     // if(val) this.refreshReportData();
    //     // else this.status[ANNUAL].loading = true
    // }
  },
  computed: {
    // keywords() {
    //   return !!this.sources.keyword.current ? `${this.sources.keyword.current}/${this.sources.keyword.total}` : "0/0";
    // },
    repeatDataUnit() {
      return this.options.unit ? this.options.unit : "--";
    },
    preYearReportYear() {
      const year = Number(this.conditions.year);
      return Number.isNaN(year) ? null : year - 1;
    },
    industryIdList: {
      get(){
        return [this.sources.industryId]
      }
    }
  },
  components: {
    FilterBar,
    // PDFViewer,
    // HightLight,
    // PDFFindbar,
    CheckedList,
    PreYearReportValuesPanel,
    DropdownSlider,
  }
};
</script>
<style lang="scss">
.my-pdf-viewer {
  // margin-top: 200px;
  height: calc(100vh - 96px);
  overflow: auto;
}
.pdf-panel {
  .adm-panel {
    padding: 0 !important;
  }
}
.pages-input {
  .checked-list {
    .checked-item {
      margin-right: 0px;
      margin-bottom: 0;
    }
  }
  .ivu-form-item-label{
    appearance: none;
    padding-bottom: 5px;
    display: block;
    text-align: left;
  }
  .ivu-form-item{
    margin-bottom: 15px;
  }
  .ivu-form-item-error-tip{
    padding-top:0;
  }
}
</style>
<style lang="scss" scoped>
hr {
  border-top: 1px solid #eee;
}

.content {
  display: flex;
  flex-flow: column nowrap;
  min-height: 538px;
}

.content-view__empty {
  flex-grow: 2;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

h3 {
  text-align: center;
  color: #ccc;
  font-size: 24px;
}
h3 i {
  font-size: 100px;
}

.filterbalaaaaar {
  display: flex;
  flex-flow: row wrap;
}
.tools {
  position: absolute;
  right: 26px;
  top: 15px;
  z-index: 99;
}

.floatButton{
    cursor: pointer;
    position: fixed;
    z-index:9999;
    white-space: nowrap;
    color: #f4f4f4;
    background-color: #2d8cf0;
    border-radius: 4px;
    padding: 4px 10px;
    box-shadow: 1px 1px 3px #333;
    > a{
      color: #f4f4f4;
    }
}
</style>
